module.exports = __webpack_public_path__ + "static/media/landing_call_back_button.bdbd38a3.svg";